import type { VoidComponent } from "solid-js";
import type { Group } from "../../../state/group";
import { editGroupSchema } from "../../../state/group";
import { useTranslation } from "../../../state/i18n";
import InputModal from "../../../components/modal/InputModal";
import { TextInput } from "../../../components/inputs/TextInput";
import type { InferInput } from "valibot";
import UserService from "../../../services/UserService";
import { useCustomerState } from "../../../state/customer";
import GenericFailureModal from "../../GenericFailureModal";
import { useModalManager } from "../../../components/modal/ModalManager";
import { toGroupDto } from "../../../utils/mappers/group";

type EditGroupModalProps = {
  group: Group;
};

const EditGroupModal: VoidComponent<EditGroupModalProps> = (props) => {
  const { t } = useTranslation();
  const customer = useCustomerState();
  const { replace } = useModalManager();

  const onConfirm = (value: InferInput<typeof editGroupSchema>) => {
    const group = props.group;
    return new Promise((resolve, reject) =>
      UserService.patchGroup(customer.customerId, group.id).mutate(
        { ...toGroupDto(group), ...value },
        {
          onSuccess: resolve,
          onError: (err) => {
            replace({
              content: () => (
                <GenericFailureModal title={t(($) => $.EDIT_GROUP_NAME_FAILURE_MODAL_TITLE)} error={err} />
              ),
            });
            reject(err);
          },
        },
      ),
    );
  };

  return (
    <InputModal
      variant="default"
      title={t(($) => $.EDIT_GROUP_NAME_MODAL_TITLE)}
      titleIcon="userGroup"
      cancelLabel={t(($) => $.CANCEL_BUTTON)}
      confirmLabel={t(($) => $.EDIT_GROUP_NAME_MODAL_SAVE_CHANGES)}
      onConfirm={onConfirm}
      initialValue={props.group}
      schema={editGroupSchema}
    >
      {({ value, updateValue, error }) => (
        <div class="flex flex-col gap-4">
          <TextInput
            label={t(($) => $.EDIT_GROUP_NAME_MODAL_NAME)}
            value={value("name")}
            required
            onBlur={(e) => {
              updateValue("name", e.target.value);
            }}
            onInput={(e) => {
              updateValue("name", e.target.value);
            }}
            errorMessage={error("name")}
          />
        </div>
      )}
    </InputModal>
  );
};

export default EditGroupModal;
